import { AssetType } from 'src/common/apollo/types/swarmx/graphql'
import { ERC20 } from 'src/common/types/models/Tokens'

export const BASE_KNOWN_ERC20: Pick<ERC20, 'logo' | 'assetType' | 'type'> = {
  logo: '',
  assetType: AssetType.NoType,
  type: 'ERC20',
}
